import PhotoListing_SimplePhotoThumb from '@Components/Listings/PhotoListing_SimplePhotoThumb';
import PhotoListing_AdvancedPhotoThumb from '@Components/Listings/PhotoListing_AdvancedPhotoThumb';
import TranslationText from '@Components/Utilities/TranslationText';

const PhotoListing_SimilarListings = (props) => {

    const renderPhotoListing = (listing) => {
        if (listing.ListingCardType == "Advanced") {
            return <PhotoListing_AdvancedPhotoThumb {...listing} key={listing.DestinationUrl} />;
        }
        else if (listing.ListingCardType == "Simple") {
            return <PhotoListing_SimplePhotoThumb {...listing} key={listing.DestinationUrl} />;
        }
    };

    return (
        <div>
            {props.listings && props.listings.length > 0 &&
                <div>
                    <h3 className='center'><TranslationText tKey='sandhills.viewsimilar' replaceValues={[props.listingType]} /></h3>
                    <div className='thumb-container'>
                    {props.listings.map(value => renderPhotoListing(value))}
                    </div>
                    {props.viewMoreUrl &&
                        <div className="centered-div-and-text similar-view-more-button">
                            <a href={props.viewMoreUrl} aria-label="view more similiar listings" className="ts-button" >{translator.translate('sandhills.viewmore').toString()}</a>
                        </div>}
                </div>}                
        </div>
    );
};

export default PhotoListing_SimilarListings;